import { useLayoutEffect, useRef, useState } from 'react';
import { ItemHeightPadding, textHeight } from '../utils/style';
export function useListItemHeightCache(values, fonts, fontKey) {
    const [itemHeight, setItemHeight] = useState();
    const refCache = useRef();
    useLayoutEffect(() => {
        const cache = (refCache.current = new ListItemHeightCache(values, textHeight(fonts)));
        setItemHeight(() => cache.getItemHeight.bind(cache));
    }, [values, fonts, fontKey]);
    return {
        itemHeight,
        refCache,
    };
}
class ListItemHeightCache {
    /**
     * Creates a new ListItemHeightCache. A new cache should be created when inputs change.
     */
    constructor(values, fontHeight) {
        this.cache = new Map();
        this.values = values !== null && values !== void 0 ? values : [];
        this.fontHeight = fontHeight !== null && fontHeight !== void 0 ? fontHeight : 0;
    }
    /**
     * Calculates the height of an item with a single line of text
     */
    getBaseItemHeight() {
        return calculateItemHeight(undefined, this.fontHeight);
    }
    /**
     * Returns the height of the item at the given index
     */
    getItemHeight(index) {
        var _a;
        const height = this.cache.get(index);
        if (height !== undefined) {
            return height;
        }
        const itemHeight = calculateItemHeight((_a = this.values) === null || _a === void 0 ? void 0 : _a[index], this.fontHeight);
        this.cache.set(index, itemHeight);
        return itemHeight;
    }
    /**
     * Calculates the total height of all items
     */
    getTotalHeight() {
        return this.values.reduce((total, _, index) => {
            return total + this.getItemHeight(index);
        }, 0);
    }
}
/**
 * Calculates the height of a list item given a string and font height
 */
function calculateItemHeight(value, fontHeight) {
    const iconHeight = 16; // checkbox or radio button
    const textHeight = countLines(value) * fontHeight;
    return Math.max(iconHeight, textHeight) + ItemHeightPadding;
}
/**
 * Counts the number of newlines in a string
 */
function countLines(string = '') {
    let lines = 1;
    for (const char of string) {
        if (char === '\n') {
            lines++;
        }
    }
    return lines;
}
